import { unique } from '~/utils/unique';
import type {
  ProductFiltersModel,
  ReadonlyProductFiltersModel
} from '~/stores/productFilterStore/model';
import {
  QUERY_KEY_NAME_PAGE,
  QUERY_KEY_NAME_SORT,
  QUERY_KEY_NAME_SORT_DIR
} from '~/stores/productFilterStore/constants';
import { isDefined } from '~/utils/guards/isDefined';

/**
 * From this values, always the last object value should be used.
 * E.g., the page filter has a default '1' and should not be merged
 * with a new page.
 *
 * @see https://gcp.baslerweb.com/jira/browse/WEB2-2283
 */
const SINGLE_VALUE_FILTERS = [
  QUERY_KEY_NAME_SORT,
  QUERY_KEY_NAME_SORT_DIR,
  QUERY_KEY_NAME_PAGE
];

export function mergeFilters(
  ...objects: ReadonlyArray<ProductFiltersModel | ReadonlyProductFiltersModel>
): ProductFiltersModel {
  const keys = unique(objects.map((o) => Object.keys(o)).flat());

  return Object.fromEntries(
    keys
      .map((key) => {
        const value = objects
          .map((o) => o[key])
          .flat()
          .filter(isDefined);

        if (SINGLE_VALUE_FILTERS.includes(key)) {
          return [key, [value.at(-1)]];
        }

        return [key, value];
      })
      .filter(([, value]) => value.length)
  );
}
